import { useState } from 'react';

  const DEFAULT_DAYS_TOKEN = 1
 const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const setCookie = (name, value, days)=> {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }
  const deleteCookie = (name) =>{
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

  const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split('=');
      if (cookieName.trim() === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }

  const login = (token,email="") => {
    localStorage.setItem('AUTH_TOKEN', token);
    localStorage.setItem('email', email);
    setCookie('AUTH_TOKEN',token,DEFAULT_DAYS_TOKEN)
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('AUTH_TOKEN');
    deleteCookie('AUTH_TOKEN')
    localStorage.removeItem('email');
    localStorage.removeItem('callback');
    setIsAuthenticated(false);
  };

  const authData = ()=>{
    const token = localStorage.getItem('AUTH_TOKEN');
    const email = localStorage.getItem('email')
    const isLogin = token !== null || getCookie('AUTH_TOKEN') !== null;
    return {token, email, isLogin}
  }

  

  return { login, logout, isAuthenticated , authData};
};


export default useAuth